import { render, staticRenderFns } from "./CommonGridContainer.vue?vue&type=template&id=cc8c857e&scoped=true"
import script from "./CommonGridContainer.vue?vue&type=script&lang=js"
export * from "./CommonGridContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonGridContainer.vue?vue&type=style&index=0&id=cc8c857e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8c857e",
  null
  
)

export default component.exports